<template>
  <div class="rightContent">
    <div class="title">
      <router-link
        to="/personal/student"
        style="color:#109eff;font-size:14px;padding-right:40px"
      >&lt; 后退</router-link>
      当前可选学分数：{{balance}}
      <span></span>
      已选学分数：
      <span>{{sum}}</span>
      <button @click="dialogVisible=true">完成选择</button>
    </div>
    <div class="table">
      <el-table
        ref="multipleTable"
        border
        row-key="ran"
        style="width: 990px"
        :data="tableData"
        tooltip-effect="dark"
        :tree-props="{children: 'videos'}"
        @selection-change="handleSelectionChange"
      >
        <el-table-column prop="cname" label="课程名" show-overflow-tooltip></el-table-column>
        <!-- <el-table-column label="课程时长" width="140" align="center">
          <template
            slot-scope="scope"
          >{{"00:00:00".slice(0,8-scope.row.duration.length)+scope.row.duration}}</template>
        </el-table-column> -->
        <!-- <el-table-column prop="credit" label="课程学分" width="100" align="center"></el-table-column> -->
        <el-table-column label="课程学分" width="100" align="center">
          <template slot-scope="scope">{{scope.row.price?scope.row.price:""}}</template>
        </el-table-column>
        <el-table-column type="selection" width="80" align="center"></el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        background
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 30, 100]"
        :page-size="10"
        prev-text="上一页"
        next-text="下一页"
        layout="sizes, prev, pager, next"
        :total="total"
      ></el-pagination>
      <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
        <span v-if="balance>=sum&&sum!=0">请确认是否完成当前选择，选择后不能撤销及更改</span>
        <span v-if="sum==0">您还未选择任何课程，请重新选择</span>
        <span v-if="balance<sum&&sum!=0">当前选择的金额大于当前余额，请重新选择</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false" v-if="balance>=sum&&sum!=0">取 消</el-button>
          <el-button type="primary" @click="_buyCourses">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { pageCoursePaySelection, buyCourses } from "@/assets/js/axios.js";
export default {
  name: "selectCourse",
  data() {
    return {
      page: 1,
      row: 10,
      currentPage: 1,
      total: 0,
      tableData: [],
      multipleSelection: [],
      sum: 0,
      balance: 0,
      dialogVisible: false,
      sumArr: [],
      oldArr: []
    };
  },
  created() {
    this._select();
  },
  methods: {
    _buyCourses() {
      if (this.balance < this.sum || this.sum == 0) {
        this.dialogVisible = false;
        return;
      }
      let cids = "";
      this.sumArr.map(el => {
        if (cids === "") {
          cids = "?cids=" + el.cid;
        } else {
          cids += "&cids=" + el.cid;
        }
      });
      this.oldArr.map(el => {
        if (cids === "") {
          cids = "?cids=" + el.cid;
        } else {
          cids += "&cids=" + el.cid;
        }
      });
      buyCourses(cids).then(res => {
        if (res.code == 1) {
          this.dialogVisible = false;
          this.$router.push({ name: "student" });
          this.$message({
            type: "success",
            message: "选课成功，点击进入学习，开始学习"
          });
        } else {
          this.$message({
            type: "error",
            message: res.msg || "未知错误请重试"
          });
        }
      });
    },
    handleSelectionChange(val) {
      let sum = 0;
      this.sumArr.map(el => {
        sum += el.price;
      });
      val.map(el => {
        sum += el.price;
      });
      this.sum = sum;
      this.oldArr = val;
    },
    handleSizeChange(val) {
      this.row = val;
      this._select();
    },
    handleCurrentChange(val) {
      this.page = val;
      this._select();
    },
    _select() {
      pageCoursePaySelection(this.page, this.row).then(data => {
        if (data.code == 1) {
          let that = this;
          this.sumArr = this.sumArr.concat(this.oldArr);
          let arr = [];
          this.tableData = data.data.courses.map((el, index) => {
            el.ran = index + "";
            el.videos = el.videos.map((els, indexs) => {
              els.ran = index + "" + indexs + 100;
              return els;
            });
            for (let i = that.sumArr.length - 1; i > -1; i--) {
              if (that.sumArr[i].cid == el.cid) {
                arr.push(el);
                that.sumArr.splice(i, 1);
                break;
              }
            }
            return el;
          });
          this.$nextTick(() => {
            arr.forEach(row => {
              this.$refs.multipleTable.toggleRowSelection(row, true);
            });
            this.oldArr = arr;
          });
          this.balance = data.data.balance;
          this.total = data.data.count;
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.table {
  /deep/ .el-table__row--level-1 {
    /deep/ .el-checkbox {
      display: none;
    }
  }
  /deep/ .el-pagination{
    /deep/ .btn-prev,.btn-next{
      min-width: 50px;
    }
  }
  /deep/ .el-table__row--level-1 .el-checkbox{
      display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/personal/selectCourse.vue